<script>
import DisbursementList from "@/components/widgets/disbursement-list.vue";
import FinanceAttachments from "@/components/modals/finance-attachments.vue";
import DVReleaseModal from "@/components/modals/dv-release-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";
export default {
    components: {
        DisbursementList,
        FinanceAttachments,
        DVReleaseModal,
        PrintOptions
    },
    data() {
        return {
            tabModel: 0,
            disbursementData: [],
            loading: false,
        }
    },
    async created(){
        this.loading = true;
        await this.getPostedDisbursements(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.loading = false;
    },
    watch: {
        tabModel: {
            immediate: true,
            handler(newVal){
                this.disbursementData = [];
                if(newVal == 0){
                    this.getPostedDisbursements(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                }else{
                    this.getReleasedDisbursements(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                }
            }
        }
    },
    methods: {
        async getPostedDisbursements(cycle, campusId){
            try{
                const { data: response } = await this.$store.dispatch("disbursement/getUnreleasedDisbursement", {cycle, campusId});
                if(response.error){
                    return this.showToast(response.message, "error");
                }
                response.map(item => item.opened = false);
                this.disbursementData = response || [];
            }catch(error){
                this.showToast("Failed to fetch disbursements.", "error");
            }
        },
        async getReleasedDisbursements(cycle, campusId){
            try{
                const { data: response } = await this.$store.dispatch("disbursement/getPostedDisbursements", {cycle, campusId});
                if(response.error){
                    return this.showToast(response.message, "error");
                }
                response.map(item => item.opened = false);
                this.disbursementData = response || [];
            }catch(error){
                this.showToast("Failed to fetch disbursements.", "error");
            }
        },
        async generateDV(disbursement){
            if(!disbursement) return;
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/Disbursement",
                routeVariables: [disbursement.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async postDV(disbursement){
            if(!disbursement) return;
            try{
                const { data: response } = await this.$store.dispatch("disbursement/PostDV", { id: disbursement.id });
                await this.getDisbursements();
            }catch(error){
                console.error(error);
                this.$bvToast.toast("Failed to post DV.", {
                    title: "Error",
                    variant: "danger",
                    solid: true
                });
            }
        },
        async getAttachments(data){
            this.$refs.finAttach.getAttachments(data.att, data.id);
            this.$bvModal.show("finance-attachment-modal");
        },
        editDisbursement(disbursement){
            if(!disbursement) return;
            this.$router.push({ name: "EditDisbursement", params: { id: disbursement.id } });
        },
        updateRelease(dv){
            this.$refs.dvReleaseModal.resetForm();
            this.$refs.dvReleaseModal.setDisbursementData(dv);
            this.$bvModal.show("dv-release-modal");
        },
        async submitDVRelease(releaseData) {
            try {
                const { data: response } = await this.$store.dispatch("disbursement/updateRelease", releaseData);
                if (response.error) {
                    return this.showToast(response.message, "error");
                }
                this.showToast("DV successfully released!", "success");
                if (this.tabModel == 0) {
                    await this.getPostedDisbursements(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                } else {
                    await this.getReleasedDisbursements(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                }
            } catch (error) {
                console.error(error);
                this.showToast("Failed to release DV.", "error");
            }
        }
    }
}
</script>
<template>
    <div >
        <b-tabs
            v-model="tabModel"
            pills
            vertical
            nav-class="pt-3"
            nav-wrapper-class="col-sm-2 border-end"
            content-class="pt-3 px-2 text-muted"
        >
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-layer text-info"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"><i class="bx bx-layer me-1"></i>Approved</span>
                </template>
                <DisbursementList 
                    type="unreleased"
                    :loading="loading"
                    :tableData="disbursementData"
                    @generateDV="generateDV"
                    @post="postDV"
                    @attachment="getAttachments"
                    @editDisbursement="editDisbursement"
                    @updateRelease="updateRelease"
                />
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-spreadsheet text-info"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"><i class="bx bx-spreadsheet me-1"></i>Posted</span>
                </template>
                <DisbursementList 
                    type="for-release"
                    :loading="loading"
                    :tableData="disbursementData"
                    @generateDV="generateDV"
                    @attachment="getAttachments"
                />
            </b-tab>
        </b-tabs>
        <FinanceAttachments 
            ref="finAttach"
        />
        <DVReleaseModal 
            ref="dvReleaseModal"
            @submit="submitDVRelease"
        />
        <PrintOptions ref="printOpt" />
    </div>
</template>